import { render, staticRenderFns } from "./RegbiteEdit.vue?vue&type=template&id=b801af3e&"
import script from "./RegbiteEdit.vue?vue&type=script&lang=js&"
export * from "./RegbiteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports